const PAID_VARIANT = 47292845260985;
const FREE_VARIANT = 47316782186681;

let isUpdating = false;

async function syncFreeGift() {
  if (isUpdating) return;
  isUpdating = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const paidItem = cart.items.find(item => item.variant_id === PAID_VARIANT);
    const freeItem = cart.items.find(item => item.variant_id === FREE_VARIANT);

    // Add free gift
    if (paidItem && !freeItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: FREE_VARIANT,
          quantity: 1
        })
      });

      refreshCartDrawer();
    }

    // Remove free gift
    if (!paidItem && freeItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: freeItem.key,
          quantity: 0
        })
      });

      refreshCartDrawer();
    }
  } finally {
    isUpdating = false;
  }
}

function refreshCartDrawer() {
  document.dispatchEvent(new CustomEvent('cart:refresh'));

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => cartDrawer.renderContents(cart));
  }
}

document.addEventListener('DOMContentLoaded', syncFreeGift);
document.addEventListener('cart:updated', syncFreeGift);